import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../../hooks/hooks';
import PageLoader from '../../../../../../components/PageLoader';
import { selectNetworksListItems } from '../../../../../../redux/dbaas/networks/selector';
import { networks } from '../../../../../../redux/dbaas/networks/action';
import { selectBiznetTypesQueryItems } from '../../../../../../redux/biznet-types/selector';
import { biznetTypes } from '../../../../../../redux/biznet-types/action';
import BizTypeComponent from '../components/dbnbiz-type.component';

const DBNBIZType = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const bizTypeQuery = useSelector(selectBiznetTypesQueryItems)
  const networkListItems = useSelector(selectNetworksListItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [
    selectedBiznetType,
    setSelectedBiznetType
  ] = useState<any>({})


  const fetchBiznetTypeById = () => {
    dispatch(biznetTypes.query({
      url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/biz-net-types/query`, entity: 'biznetTypes', jsonData: {

        Records: [
          {
            Id: parmas?.id
          }
        ]

      }
    })).then(() => {
      setIsQuery(true)
    }).then(() => {
      setIsLoading(false)
    })
  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedBiznetType({ ...selectedBiznetType, [field]: event });
  }

  useEffect(
    () => {
      dispatch(networks.list({
        url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/dbaas/networks/list`, entity: 'networks', jsonData: {}
      })).then(() => {
        if (parmas?.id > 0) {
          fetchBiznetTypeById()
          setIsLoading(false)
        } else {
          setIsLoading(false)
        }
      })
    },
    []
  )
  useEffect(
    () => {

      if (isQuery) {
        setSelectedBiznetType(bizTypeQuery?.result?.items)
      }
    },
    [isQuery]
  )

  const back = () => {
    navigate('/management/dbn-cloud/dbnbizs/dbnbiz-types')
  }

  return (
    <>
      {isLoading ? <PageLoader /> :
        <BizTypeComponent
          networks={networkListItems?.result?.items}
          selectedBiznetType={selectedBiznetType}
          handleInnerFormChange={handleInnerFormChange}
          back={back}
        />
      }
    </>
  )

}

export default DBNBIZType;